import script from "./StudentResultShow.vue?vue&type=script&setup=true&lang=js"
export * from "./StudentResultShow.vue?vue&type=script&setup=true&lang=js"

export default script